import React, { useState } from 'react';
import {
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';
import DocumentList from 'components/documents/DocumentList';
import { PageHeader, PageShell } from 'components/layout/PageShell';
import { UnifiedPageSection } from 'components/layout/UnifiedPrimitives';

const AdminInvoicesPage = () => {
  const { t } = useTranslation();
  const [refreshTrigger] = useState(0);

  return (
    <PageShell>
      <VStack spacing={6} align="stretch">
        <PageHeader
          title={t('Invoices')}
          description={t('Review payout invoices uploaded by partners and keep payout processing organized.')}
        />

        <UnifiedPageSection
          title={t('Partner Payout Invoices')}
          description={t('Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.')}
        >
          <DocumentList
            isInvoice={true}
            refreshTrigger={refreshTrigger}
            canDelete={true}
            canMarkPaid={true}
          />
        </UnifiedPageSection>
      </VStack>
    </PageShell>
  );
};

export default AdminInvoicesPage;
